import React from 'react';
import './Styles/work.css';
import { WorkItem } from './Components/WorkItem'
import About from './About';

const workArray = [
	{
		title: "Aevi",
		type: "Developed w/ Sarah Holden",
		tech: ['shopify'],
		url: "https://liveaevi.com/"
	},
	{
		title: "Inside Company",
		type: "Portfolio",
		tech: ['react', 'gatsby', 'sanity (cms)'],
		url: "https://www.inside.company/"
	},
	{
		title: "Claire Arnold",
		type: "Portfolio",
		tech: ['react', 'contentful'],
		url: "http://claire-arnold.com/#/"
	},
	{
		title: "Rare Medium",
		type: "Emag",
		tech: ['react'],
		url: "http://raremediummag.com/"
	},
	{
		title: "Adam Uhl",
		type: "Portfolio website for DP Adam Uhl",
		tech: ['Contentful (cms)', "Next"],
		url: "https://adam-uhl.com/"
	},
	{
		title: "Arielle Berman Casting",
		type: "Portfolio",
		tech: ['react'],
		url: "http://ariellebermancasting.com/#/"
	},
	{
		title: "North Moore",
		type: "Portfolio",
		tech: ['react'],
		url: "http://north-moore.com/"
	},
	{
		title: "Kevin Kloecker",
		type: "Portfolio",
		tech: ['squarepace'],
		url: "http://www.kevinkloecker.com/"
	},
	{
		title: "Molly Moorkamp",
		type: "Ecommerce",
		tech: ['ecommerce', 'shopify'],
		url: "https://mollymoorkamp.com/"
	},
	{
		title: "Ilona Klaver",
		type: "Portfolio",
		tech: ['wordpress'],
		url: "http://www.ilonaklaver.com/"
	}
]


const Work = () => {
	return (
		<div className="App work">
			<main>
				<section>
					<h1>Madeline O'Moore</h1>
					<h2 className="hide-element">About Me</h2>
					<About />
				</section>
				<section>
					<h2>Selected Work</h2>
					{workArray.map((project, i) => {
						return (
							<WorkItem  {...project} key={i} />
						)
					})}
				</section>
			</main>
		</div>
	);

}

export default Work;



// WEBPACK FOOTER //
// ./src/Pages/Work.js